import { render } from "./AdditionalFiltersWidget.vue?vue&type=template&id=471b4704&scoped=true"
import script from "./AdditionalFiltersWidget.vue?vue&type=script&lang=js"
export * from "./AdditionalFiltersWidget.vue?vue&type=script&lang=js"

import "./AdditionalFiltersWidget.vue?vue&type=style&index=0&id=471b4704&scoped=true&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471b4704"]])

export default __exports__